import api from "./api";
import axios from "axios";
import versioniSottoProgettiManager from "./SottoProgettiVersione";

class SottoProgettiManager {

    sottoprogetti(config?: any) {
        return api.get(`/sottoprogetti`, config)
    }

    sottoprogetto(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}`, config)
    }

    sottoprogettoUpdate(sottoprogetto_id: number | string, data: any) {
        return api.put(`/sottoprogetti/${sottoprogetto_id}`, data)
    }

    mySottoprogetti(config?: any) {
        return api.get(`me/sottoprogetti`, config)
    }

    autoversiona(sottoprogetto_id: number | string, data: any) {
        return api.post(`/sottoprogetti/${sottoprogetto_id}/versioni`, data)
    }

    versionaManualmente(sottoprogetto_id: number | string, data: any) {
        return api.put(`/sottoprogetti/${sottoprogetto_id}/versioni`, data)
    }

    versioni(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/versioni`, config)
    }

    accounts(sottoprogetto_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/accounts`)
    }

    projectManagers(sottoprogetto_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/project_managers`)
    }

    direttoriProduzione(sottoprogetto_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/direttori_produzione`)
    }

    briefFiles(sottoprogetto_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/brief_files`)
    }

    cambiaStato(sottoprogetto_id: number | string, data: any) {
        return api.post(`/sottoprogetti/${sottoprogetto_id}/cambia_stato`, data)
    }

    defaultConf(sottoprogetto_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/default_conf`)
    }

    creaOda(sottoprogetto_id: number | string, fornitore_id: number | string, data: any) {
        return api.post(`/sottoprogetti/${sottoprogetto_id}/fornitori/${fornitore_id}/oda`, data);
    }

    canCreaOda(sottoprogetto_id: number | string, fornitore_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/fornitori/${fornitore_id}/can_create_oda`);
    }

    odvs(sottoprogetto_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/odvs/`);
    }

    creaOdv(sottoprogetto_id: number | string) {
        return api.post(`/sottoprogetti/${sottoprogetto_id}/odvs/`);
    }

    getStatiPossibili(sottoprogetto_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/possibili_stati/`)
    }

    pianoDiFatturazione(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/piano_di_fatturazione/`, config)
    }

    setDestinatario(sottoprogetto_id: number | string, data: any) {
        return api.put(`/sottoprogetti/${sottoprogetto_id}/destinatario/`, data)
    }

    importFrom(sottoprogetto_id: number | string, sottoprogetto_from_id: number | string, versione_from_id: number | string,) {
        return api.post(`/sottoprogetti/${sottoprogetto_id}/importfrom/${sottoprogetto_from_id}/versione/${versione_from_id}/`)
    }

    gamma(sottoprogetto_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/gamma/`)
    }

    contratto(sottoprogetto_id: number | string, data: any) {
        return api.post(`/sottoprogetti/${sottoprogetto_id}/contratto/`, data)
    }

    costiRicavi(sottoprogetto_id: number | string) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/`)
    }

    costiCarte(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/costi_carte/`, config)
    }

    costiBiglietteriaFerroviaria(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/costi_biglietteria_ferroviaria/`, config)
    }

    costiBiglietteriaAerea(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/costi_biglietteria_aerea/`, config)
    }

    incassiPagamenti(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/incassi_pagamenti/`, config)
    }

    costiPreventivo(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/costi_preventivo/`, config)
    }

    costiNoteSpesa(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/costi_note_spesa/`, config)
    }

    exportCostiNoteSpesa(sottoprogetto_id: number | string, config?:any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/costi_note_spesa/export`, config)
    }

    fattureClienti(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/fatture_cliente`, config)
    }

    fattureFornitore(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/fatture_fornitore`, config)
    }

    costiTimesheet(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/costi_timesheet/`, config)
    }

    costiFinanziari(sottoprogetto_id: number | string,config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/costi_finanziari/`, config)
    }

    costiContratti(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/costi_contratti/`, config)
    }

    ricavi(sottoprogetto_id: number | string,config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/costi_ricavi/ricavi/`, config)
    }

    importExcel(sottoprogetto_id: number | string, data: any) {
        return api.post(`/sottoprogetti/${sottoprogetto_id}/import_excel/`, data)
    }

    documentiFornitori(sottoprogetto_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/documenti_fornitori/`, config)
    }

    creaDocumentoFornitore(sottoprogetto_id: number | string, data: any) {
        return api.post(`/sottoprogetti/${sottoprogetto_id}/documenti_fornitori/`, data)
    }

    exportSottoprogetto(sottoprgettoId: number | string, data: any) {
        return api.get(`/sottoprogetti/${sottoprgettoId}/export`, data)
    }

    retrieve = this.sottoprogetto
    list = this.sottoprogetti
}

const sottoProgettiManager = new SottoProgettiManager()

export default sottoProgettiManager

class SottoProgettiVersioneManager {
    list = sottoProgettiManager.versioni
    retrieve = versioniSottoProgettiManager.versione
}

export const sottoProgettiVersioneManager = new SottoProgettiVersioneManager()

